/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta' // Vue.js plugin that allows you to manage your app's metadata
import store from '../store'

// Routes
import paths from './paths'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    // native-like behavior when navigating with back/forward buttons
    if (savedPosition) {
      return savedPosition
    }

    // scroll to anchor
    if (to.hash) {
      return { selector: to.hash }
    }

    // scroll to top
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  to.matched.some(record => {
    if (to.path === '/login') {
      next()
      return
    }

    if (record.meta.requiresAuth) {
      if (!store.getters.authorized) {
        next('/login')
        return   
      }    
    }

    let userPermissions = store.state.permissions
    if (userPermissions.length <= 0) {
      store.dispatch('getUserPermissions')
        .then((response) => {
          userPermissions = response.data  

          const requiredPermission = record.meta.permission
          if (!requiredPermission) {
            next()
            return
          }
      
          const hasPermission = userPermissions.find(perm => perm.name === requiredPermission)
          if (!hasPermission) next('/permissions/deny')
        })
        .catch(() => {
          next()
        })
    } else {
      const requiredPermission = record.meta.permission
      if (!requiredPermission) {
        next()
        return
      }
  
      const hasPermission = userPermissions.find(perm => perm.name === requiredPermission)
      if (!hasPermission) next('/permissions/deny')
    }
  })
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development',
    },
  })
}

export default router
